import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayDate = (value) =>
  value && moment(value).isValid() ? moment(value).format('DD MMMM YYYY') : '—';

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const fileLink = (file) => {
  const url = file?.file_url || file?.url;
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      {file?.file_name || file?.name || url}
    </a>
  );
};

const getVisitModeLabel = (mode, t) => {
  const labels = {
    by_person: t('Di persona'),
    by_phone: t('Telefonico'),
    by_videocall: t('Videocall'),
    other: t('Altro (specificare a fondo pagina nelle note)'),
  };
  return labels[mode] || display(mode);
};

const getVisitTypeLabel = (type, t) => {
  const labels = {
    offer: t('Proposta commerciale'),
    credits: t('Recupero crediti'),
    interlocutory: t('Interlocutorio'),
  };
  return labels[type] || display(type);
};

const getStatusLabel = (status, t) => {
  const labels = {
    in_progress: t('In corso'),
    done: t('Conclusa'),
    resend: t('Rinviata'),
    failed: t('Fallita'),
    not_interested: t('Non interessati'),
  };
  return labels[status] || display(status);
};

export const getVisitCardViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Info'),
      fields: [
        {
          text: t('Referente brand'),
          value: display(item.leasings_contact),
        },
        {
          text: t('Azienda'),
          value: display(item.company_title || item.company_name),
        },
        {
          text: t('Leasing manager'),
          value: display(item.leasings_manager?.name),
        },
        {
          text: t('Asset di riferimento'),
          value: display(item.leasings_asset),
        },
        {
          text: t('Unità di riferimento'),
          value: display(item.leasings_room),
        },
        {
          text: t('Tipo di incontro'),
          value: display(item.leasings_meeting_type?.title),
        },
        { text: t('Data incontro'), value: displayDate(item.visit_date) },
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Oggetto dell’incontro'),
          value: display(item.visit_subject),
        },
        {
          text: t('Luogo dell’incontro'),
          value: display(item.visit_place),
        },
        {
          text: t('Persone presente all incontro'),
          value: display(item.visit_persons),
        },
        {
          text: t('Modalità di incontro'),
          value: getVisitModeLabel(item.visit_mode, t),
        },
      ],
    },
    {
      title: t('Dati economici'),
      fields: [
        {
          text: t('Dati economici discussi'),
          value: displayBool(item.is_edit_data, t),
        },
        { text: t('Affitto minimo'), value: display(item.min_rent_rate) },
        { text: t('Service charge'), value: display(item.service_charge) },
        { text: t('Affitto variabile'), value: display(item.rent_variable) },
        { text: t('Rachet'), value: display(item.rachet) },
        { text: t('Break option'), value: display(item.break_option) },
        {
          text: t('Durata contrattuale'),
          value: display(item.contract_duration),
        },
        { text: t('Uplift'), value: display(item.uplift) },
        {
          text: t('Capital contribution'),
          value: display(item.capital_contribution),
        },
      ],
    },
    {
      title: t('Allegati'),
      fields: [
        { text: t('Allegato 1'), value: fileLink(item.first_file) },
        { text: t('Allegato 2'), value: fileLink(item.second_file) },
        { text: t('Hot'), value: fileLink(item.hot_file) },
      ],
    },
    {
      title: t('Note'),
      fields: [
        {
          text: t('Outcome dell’incontro'),
          value: display(item.outcome_note),
        },
        {
          text: t('Note commerciale'),
          value: display(item.commercial_note),
        },
      ],
    },
    {
      title: t('Stato trattativa'),
      fields: [
        {
          text: t('Stato trattativa'),
          value: getStatusLabel(item.status, t),
        },
      ],
    },
  ];
};
